export default "__VITE_ASSET__DQRtnnuM__"